import { render, staticRenderFns } from "./WelcomePhoneCheck.vue?vue&type=template&id=6ddbcb20&scoped=true&"
import script from "./WelcomePhoneCheck.vue?vue&type=script&lang=js&"
export * from "./WelcomePhoneCheck.vue?vue&type=script&lang=js&"
import style0 from "./WelcomePhoneCheck.vue?vue&type=style&index=0&id=6ddbcb20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ddbcb20",
  null
  
)

export default component.exports